window.Samcart.Embed.Core.registerModule('PreRendered', (function () {

    /**
     *
     * @constructor
     */
    function PreRendered() {

    }

    /**
     * This module expects to execute on tags that are rendered by the browser and not by embed.js
     *
     * @type {string}
     */
    PreRendered.prototype.render_type = 'prerendered';

    /**
     * Elements must have the sc-embed='custom' attribute
     *
     * @param {Element} ele
     * @returns {boolean}
     */
    PreRendered.prototype.elementMatchesModule = function(ele) {
        return (ele.getAttribute('sc-embed') === 'custom');
    };

    /**
     * While most embed.js components use the tag to register themselves, PreRendered uses the tag to
     * lookup the target of click events
     *
     * @param marketplaceToken
     * @param productSlug
     * @returns {string}
     */
    PreRendered.prototype.getTargetComponentTag = function(marketplaceToken, productSlug) {
        return (marketplaceToken + '-' + productSlug + '-click').toLowerCase();
    };


    /**
     * Elements must have an href attribute even if they are not anchor tags
     *
     * @param ele
     * @returns {(string | null) | string}
     */
    PreRendered.prototype.getTargetURL = function(ele) {
        var url = ele.getAttribute('sc-url') || ele.getAttribute("href");
        return url;

    };

    return new PreRendered();
})());